<template>
  <div
    v-if="!$params.iframe"
    v-track:impression="{ event: `homepage:homeOwnerTeaserImpression` }"
    class="container-fluid-lg relative"
  >
    <img
      loading="lazy"
      :src="block.content.image + '/' + transformation"
      :alt="block.content.alt"
      class="h-[32rem] w-full rounded-lg object-cover"
    />
    <div class="absolute inset-0 rounded-lg bg-black/5"></div>
    <div
      class="absolute left-4 right-4 top-0 flex h-full max-w-[100vw] flex-col items-start justify-center gap-8 text-txt-contrast sm:left-8 md:left-16 md:w-1/3"
    >
      <h2 class="max-w-full text-3xl font-medium md:text-4xl">
        {{ block.content.title }}
      </h2>
      <span class="text-2xl font-medium">{{ block.content.subtitle }}</span>
      <WebccButton size="lg" variant="cta" class="min-w-1/2" @click="register">
        <span>{{ block.content.buttonText }}</span>
      </WebccButton>
    </div>
  </div>
</template>

<script setup lang="ts">
const transformations = {
  xl: 'tr:w-1280,h-400',
  lg: 'tr:w-1280,h-400',
  md: 'tr:w-1280,h-400',
  sm: 'tr:w-1280,h-400',
  xs: 'tr:w-854,h-480',
}

const props = defineProps<{
  block: Block<OwnerTeaserBlockContent>
}>()

const transformation = computed(
  () => transformations[useScreen().current] || 'tr:w-900,h-560',
)

function register() {
  useTracking().handlers?.homepage.homeOwnerTeaserClick()
  window.open(
    props.block.content.link.href,
    props.block.content.link.target.length
      ? props.block.content.link.target
      : '_blank',
  )
}
</script>
